import { render } from "./Mapping.vue?vue&type=template&id=99aff7e6"
import script from "./Mapping.vue?vue&type=script&lang=js"
export * from "./Mapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/Mapping.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99aff7e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99aff7e6', __exports__)) {
    api.reload('99aff7e6', __exports__)
  }
  
  module.hot.accept("./Mapping.vue?vue&type=template&id=99aff7e6", () => {
    api.rerender('99aff7e6', render)
  })

}


export default __exports__